import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

/**
 * Znacznik odbioru osobistego zapisywany przez guest-hub w `roomNumber`
 * (click & collect nie ma numeru pokoju, więc pole niesie tag zamiast liczby).
 */
export const TAKE_TO_ROOM_TAG = 'TAKE_TO_ROOM';

/** Czy zamówienie jest do odbioru osobistego, a nie do pokoju. */
export const isSelfPickup = (roomNumber?: string | null): boolean => (roomNumber ?? '').trim().toUpperCase() === TAKE_TO_ROOM_TAG;

// Żółte tło i czarny napis — plakietka ma wyskoczyć z rzędu, bo zmienia sposób
// obsługi zamówienia (gość przyjdzie po odbiór zamiast dostawy do pokoju).
const PickupBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  /* Wyraźniejszy żółty (Tailwind yellow-400) z czarnym tekstem. */
  background: #facc15;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
  color: #000000;
`;

interface OrderLocationProps {
  roomNumber?: string | null;
  /** Co pokazać, gdy pokoju brak (domyślnie myślnik). */
  fallback?: string;
}

/**
 * Miejsce realizacji zamówienia: numer pokoju albo — przy odbiorze osobistym —
 * plakietka „Odbiór". Surowy tag `TAKE_TO_ROOM` nic obsłudze nie mówił, a numer
 * pokoju w takim zamówieniu po prostu nie istnieje.
 */
export const OrderLocation: FC<OrderLocationProps> = ({ roomNumber, fallback = '—' }) => {
  const { t } = useTranslation();

  if (isSelfPickup(roomNumber)) {
    return <PickupBadge>{t('orders.selfPickup', 'Odbiór własny')}</PickupBadge>;
  }

  return <span>{roomNumber || fallback}</span>;
};
